/** australian mobiles: 04, +614 or +6104 followed by 8 digits,
 *
 * international mobiles: + followed by 7-15 digits but not starting with +61  */
export const mobileNumberRegex = /^((04|\+614|\+6104)[0-9]{8})$|^(\+(?!61)[0-9]{7,15})$/;

/** If the number is a valid Australian or International mobile number,
 *
 * - strip non-numeric and non `+` characters
 * - replace leading `04` with `+614`
 *
 * Otherwise return the input value unchanged
 */
export const formatNumber = (value: string) => {
	// if number is not valid, return dirty value so users don't get confused.
	// It's the form validation's job to prevent dirty values from being submitted
	if (isNumberValid(value) === false) {
		return value;
	}

	let sanitizedValue = sanitizeNumber(value);

	// replace leading 04 with +614
	if (sanitizedValue.substr(0, 2) === "04") {
		sanitizedValue = sanitizedValue.replace("04", "+614");
	}
	return sanitizedValue;
};

/** Returns whether the phone number is a valid Australian or International mobile number */
export const isNumberValid = (
	/** the phone number to validate */
	value: string,
) => {
	let sanitizedValue = sanitizeNumber(value);
	return !!sanitizedValue.match(mobileNumberRegex);
};

/** strips non-numeric and non `+` characters */
export const sanitizeNumber = (number: string) => {
	return number.replace(new RegExp(/[^+|\d]/, "g"), "");
};
